
import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";

const AppPromo = () => {
  const { t } = useLanguage();
  
  return (
<section className="mt-8 md:mt-16 py-4 md:py-8 bg-brand-darker relative overflow-visible">
  <div className="container mx-auto px-4">
    <div className="banner bg-gradient-to-r from-brand-red to-pink-600 flex flex-col md:flex-row items-center justify-between relative overflow-visible py-8 md:pt-24 md:pb-24 rounded-2xl md:rounded-[30px] px-4 md:pl-[50px] animate-scale-in animate-delay-200 hover-lift">
      <div className="w-full md:w-1/2 z-10 mb-6 md:mb-0">
            <h3 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-3 animate-slide-in-right animate-delay-300 leading-tight">
              <span className="block">{t('app.downloadOurApp')}</span>
              <span className="block">{t('app.app')}</span>
            </h3>
            <p className="text-white/80 mb-6 text-sm md:text-base animate-slide-in-right animate-delay-400">{t('app.trackYourStorepoints')}</p>

            <div className="flex flex-wrap gap-3 animate-fade-in animate-delay-500">
            <a href="https://apps.apple.com/pt/app/dartsbeat-user-app/id1547213108" className="inline-block hover-scale">
              <img
                src="/lovable-uploads/as-400x144.png"
                alt="App Store"
                className="h-10 md:h-12 object-contain"
              />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.spoplatform.dartsbeatuser" className="inline-block hover-scale">
              <img
                src="/lovable-uploads/gp-400x144.png"
                alt="Google Play"
                className="h-10 md:h-12 object-contain"
              />
            </a>
            </div>
          </div>
          {/* App Image */}
          <div className="w-full md:w-1/2 mt-0 md:mt-0 z-10 relative animate-slide-in-left animate-delay-400 flex items-center justify-center">
            <img
                    src="/lovable-uploads/0b9cfb40-6edb-4231-9ab5-7f5ae01c1dc8.png"
                    alt="DartsBeat App"
              className="w-auto h-[200px] md:h-auto max-w-[200px] md:max-w-md mx-auto object-contain md:absolute md:bottom-[-200px] md:left-1/2 md:-translate-x-1/2 animate-float"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppPromo;
